import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function RegisterEmployer() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { register: eRegister, reset: eReset, handleSubmit: eHandleSubmit, errors: eErrors, getValues: eGetValues } = useForm();
  const [submitting, setSubmitting] = useState(false);

  const signUpEmployer = (value) => {
    setSubmitting(true);
    axios.post("/api/employer/register", value).then((response) => {
      enqueueSnackbar(response.data.message, { variant: response.data.status });
      if (response.data.status == "success") {
        eReset();
        history.push("/login-employer");
      }
    }).finally(() => {
      setSubmitting(false);
    });
  };

  return (
    <div className="section-full p-t60 p-b0 bg-white">
  
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <figure className="account-image">
              <img src="/portal/images/LoginBGImg-Photoroom.png" alt="info image" />
            </figure>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="twm-log-reg-form-wrap">
              <h2 className="wt-title">Welcome to Employer Zone</h2>
              <p className="twm-log-reg-subtitle">
                Find qualified talent faster with our smart, efficient, and easy-to-use hiring platform.
              </p>
              <p className="text-muted small mb-3">
                <span className="text-danger">*</span> All fields are required.
              </p>
              <div className="radio_tabs">
                <ul>
                  <li>
                  <Link to="/login-employer">
                    <input type="radio" name="radiotab" />Login
                  </Link>
                  </li>
                  <li className="active">
                    <Link to="/register-employer">
                      <input type="radio" name="radiotab" checked /> Register
                    </Link>
                  </li>
                </ul>
              </div>
              <form onSubmit={eHandleSubmit(signUpEmployer)}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <input
                        name="username"
                        type="text"
                        id="username"
                        className={`form-control ${
                          eErrors.username !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Full Name"
                        ref={eRegister({
                          required: "Please enter a full name",
                        })}
                        autoComplete="name"
                      />
                      {eErrors.username && (
                        <div id="usernameFeedback" className="text-danger">
                          {eErrors.username.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <input
                        name="email"
                        type="email"
                        id="email"
                        className={`form-control ${
                          eErrors.email !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Email"
                        ref={eRegister({
                          required: "Please provide a valid email.",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      {eErrors.email && (
                        <div id="emailFeedback" className="text-danger">
                          {eErrors.email.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div
                      className="form-group mb-3 position-relative"
                      id="passwords-group"
                    >
                      <input
                        name="password"
                        type="password"
                        id="passwords"
                        className={`form-control ${
                          eErrors.password !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Password"
                        ref={eRegister({
                          required: "Password field is required",
                          minLength: {
                            value: 8,
                            message:
                              "Password must be minimun of 8 characters",
                          },
                        })}
                      />
                      <div
                        className="showPassword"
                        data-relative="#passwords-group"
                        data-formid="#passwords"
                        data-show="false"
                        // style={{
                        //   position: "absolute",
                        //   right: "10px",
                        //   top: "5px",
                        //   cursor: "pointer",
                        // }}
                      >
                        <i className="ri-eye-fill"></i>
                      </div>
                      {eErrors.password && (
                        <div id="passwordFeedback" className="text-danger">
                          {eErrors.password.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div
                      className="form-group mb-3 position-relative"
                      id="passwords_confirmation-group"
                    >
                      <input
                        name="password_confirmation"
                        type="password"
                        id="passwords_confirmation"
                        className={`form-control ${
                          eErrors.password_confirmation !== undefined
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Confirm Password"
                        ref={eRegister({
                          required: "Please confirm your password",
                          validate: (value) =>
                            value === eGetValues("password") ||
                            "Password does not match",
                        })}
                      />
                      <div
                        className="showPassword"
                        data-relative="#passwords_confirmation-group"
                        data-formid="#passwords_confirmation"
                        data-show="false"
                        // style={{
                        //   position: "absolute",
                        //   right: "10px",
                        //   top: "5px",
                        //   cursor: "pointer",
                        // }}
                      >
                        <i className="ri-eye-fill"></i>
                      </div>
                      {eErrors.password_confirmation && (
                        <div
                          id="password_confirmationFeedback"
                          className="text-danger"
                        >
                          {eErrors.password_confirmation.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <input
                        name="mobile"
                        type="number"
                        id="mobile"
                        className={`form-control ${
                          eErrors.mobile !== undefined ? "is-invalid" : ""
                        }`}
                        placeholder="Mobile"
                        ref={eRegister({
                          required: "Please enter a mobile number",
                          minLength: {
                            value: 10,
                            message: "Mobile number must be 10 digits long",
                          },
                          maxLength: {
                            value: 10,
                            message: "Mobile number must be 10 digits long",
                          },
                        })}
                      />
                      {eErrors.mobile && (
                        <div id="mobileFeedback" className="text-danger">
                          {eErrors.mobile.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <div className=" form-check">
                        <input
                          type="checkbox"
                          name="terms_condition"
                          className={`form-check-input ${
                            eErrors.terms_condition !== undefined
                              ? "is-invalid"
                              : ""
                          }`}
                          id="acceptTerms"
                          defaultValue="Y"
                          ref={eRegister({
                            required: "Required",
                          })}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="acceptTerms"
                        >
                          I agree to the{" "}
                          <Link to={`/pages/terms-and-conditions`} target="_blank">Terms and conditions</Link> and 
                          <Link to={`/pages/privacy-policy`} target="_blank"> Privacy Policy</Link>
                        </label>
                        <p>
                          Already registered?
                          <Link to="/login-employer"> Log in here </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <button type="submit" className="site-button" disabled={submitting}>
                      {submitting ? "Signing Up..." : "Sign Up"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

    </div>
  );
}
